import { FC, useState } from "react";
import Image from "next/image";

import ImageCarousel from "./image-carousel";

import { getMediaSizes, imageLoader } from "@utils/get-media";
import ResponsiveSlider from "@components/common/responsive-slider";

export const MobileImageGallery: FC<Props> = ({ photos }) => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [initialSlide, setInitialSlide] = useState(0);

  return (
    <>
      <ResponsiveSlider {...{ breakpoints: { base: 1 } }}>
        {photos.map((image, index) => (
          <div
            className="aspect-w-1 aspect-h-1" /* "aspect-w-8 aspect-h-10" */
            key={image}
            onClick={() => {
              setInitialSlide(index);
              setShowCarousel(true);
            }}
          >
            <Image
              src={image}
              alt="Product photo"
              layout="fill"
              objectFit="contain"
              loader={imageLoader}
              sizes={getMediaSizes([
                { breakpoint: "sm", size: "90vw" },
                { size: "25vw" },
              ])}
              className="hover:scale-110 transition-all duration-150"
            />
          </div>
        ))}
      </ResponsiveSlider>
      <ImageCarousel
        show={showCarousel}
        hide={() => setShowCarousel(false)}
        initialSlide={initialSlide}
        customPaging={(index) => (
          <a className="block aspect-w-8 aspect-h-10">
            <Image
              src={photos[index]}
              alt="Product photo"
              layout="fill"
              objectFit="cover"
              loader={imageLoader}
              sizes={getMediaSizes([{ size: "10vw" }])}
            />
          </a>
        )}
      >
        {photos.map((image) => (
          <div key={image}>
            <div className="p-4 h-full max-w-[80vh] mx-auto">
              <div className="aspect-w-8 aspect-h-11">
                <Image
                  src={image}
                  alt="Product photo"
                  layout="fill"
                  objectFit="cover"
                  loader={imageLoader}
                  sizes={getMediaSizes([{ size: "50vw" }])}
                />
              </div>
            </div>
          </div>
        ))}
      </ImageCarousel>
    </>
  );
};

interface Props {
  photos: string[];
}

const ImageGallery: FC<Props> = ({ photos }) => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [initialSlide, setInitialSlide] = useState(0);

  return (
    <div className="grid-cols-1 md:grid-cols-6 w-full gap-3 p-4 grid">
      {photos.map((image, index) => {
        return (
          <div
            key={image}
            className={`col-span-1 cursor-pointer overflow-hidden ${
              index > 1 && index < 5 ? "md:col-span-2" : "md:col-span-3"
            }`}
            onClick={() => {
              setInitialSlide(index);
              setShowCarousel(true);
            }}
          >
            <div className="aspect-w-8 aspect-h-10">
              <Image
                src={image}
                alt="Product photo"
                layout="fill"
                objectFit="cover"
                loader={imageLoader}
                sizes={getMediaSizes([
                  { breakpoint: "sm", size: "90vw" },
                  { size: "25vw" },
                ])}
                className="hover:scale-110 transition-all duration-150"
              />
            </div>
          </div>
        );
      })}
      <ImageCarousel
        show={showCarousel}
        hide={() => setShowCarousel(false)}
        initialSlide={initialSlide}
        customPaging={(index) => (
          <a className="block aspect-w-8 aspect-h-10">
            <Image
              src={photos[index]}
              alt="Product photo"
              layout="fill"
              objectFit="cover"
              loader={imageLoader}
              sizes={getMediaSizes([{ size: "10vw" }])}
            />
          </a>
        )}
      >
        {photos.map((image) => (
          <div key={image}>
            <div className="p-4 h-full max-w-[80vh] mx-auto">
              <div className="aspect-w-8 aspect-h-10">
                <Image
                  src={image}
                  alt="Product photo"
                  layout="fill"
                  objectFit="cover"
                  loader={imageLoader}
                  sizes={getMediaSizes([{ size: "50vw" }])}
                />
              </div>
            </div>
          </div>
        ))}
      </ImageCarousel>
    </div>
  );
};

export default ImageGallery;
